import { CommerceAddress } from '../address/checkout-addresses.interface';
import { ContactForm } from '../contact-form.interface';

import { Checkout } from './checkout.model';

export interface IExpressBuyNowItem {
  sku: string;
  quantity: number;
  nonMerch: boolean;
}

export interface IAddToExpressBuyNowCartRequest {
  items: IExpressBuyNowItem[];
}

export interface ICreateExpressCheckoutResponse {
  checkout: Checkout;
  checkoutIdCookie: string | null;
  checkoutAccessKeyCookie: string | null;
}

export enum ExpressCheckoutAddressType {
  SHIPPING_BILLING = 'SHIPPINGBILLING',
  SHIPPING = 'SHIPPING',
  BILLING = 'BILLING',
}

export interface ExpressCardState {
  isLoading: boolean;
  status: ExpressFormCardStatus;
}

export enum ExpressFormCardStatus {
  COMPLETE = 'complete',
  DEFAULT = 'default',
  OPEN = 'open',
  REVISE = 'revise',
}

export interface IExpressCheckoutAddressRequest {
  firstName: string;
  lastName: string;
  address: string;
  address2?: string;
  zipcode: string;
  city: string;
  state: string;
  country: string;
  phone: string;
  email: string;
}

export interface ExpressBillingSaveResult {
  success: boolean;
  error?: unknown;
}

export interface ExpressContactInfoSectionInfo {
  contactForm: ContactForm;
  address: CommerceAddress | null;
}
